import { graphql } from '~/graphql/generated/gql';

export const LESSON_SHARED_BY_CODE = graphql(`
  query lessonSharedByCode($code: String!) {
    lessonSharedByCode(code: $code) {
      lessonId
      learningAssetCollectionId
      audience
      title
      slug
      coverImageUrl
      schoolId
      teacherDisplayName
      viewerCanOpen
    }
  }
`);
